export default __webpack_public_path__ + "static/media/sensotrend_connect_upload_data1.d1519e47.png";